import Icon from "components/icon";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";
import { BreadcrumbStageType } from "./breadcrumb";

export const StyledBreadcrumb = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;

interface StageProps {
  $stage: BreadcrumbStageType;
}

export const StyledStage = styled.div<StageProps>`
  ${fontQuicksand()};
  font-size: 0.875rem;
  cursor: default;
  display: flex;
  text-align: center;

  ${(props) =>
    props.$stage === "past" &&
    css`
      color: ${Colors.BLUE};
    `};
  ${(props) =>
    props.$stage === "current" &&
    css`
      color: ${Colors.BLUE};
      font-weight: 700;
    `};
  ${(props) =>
    props.$stage === "future" &&
    css`
      color: ${Colors.BLUE};
      opacity: 0.75;
    `};
`;

export const StyledSeperator = styled(Icon)`
  font-size: 0.675rem;
`;
